/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/promotion';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "CreatePromotionRequest": {
                    "fields": {
                      "promotion": {
                        "type": "squareup.solidshop.v2.resources.Promotion",
                        "id": 1,
                        "rule": "optional"
                      },
                      "usageLimit": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 1
                        }
                      }
                    }
                  },
                  "CreatePromotionResponse": {
                    "fields": {
                      "promotion": {
                        "type": "squareup.solidshop.v2.resources.Promotion",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE CreatePromotionRequest @ squareup/solidshop/v2/service/promotions/create_promotion.proto at 11:1
 */
export const CreatePromotionRequest = $root.lookupType('squareup.solidshop.v2.service.CreatePromotionRequest');
fixType(CreatePromotionRequest);
Builder.createAndAttachToType(CreatePromotionRequest);
/**
 * SOURCE CreatePromotionResponse @ squareup/solidshop/v2/service/promotions/create_promotion.proto at 16:1
 */
export const CreatePromotionResponse = $root.lookupType('squareup.solidshop.v2.service.CreatePromotionResponse');
fixType(CreatePromotionResponse);
Builder.createAndAttachToType(CreatePromotionResponse);
